import styled from 'styled-components'

export const IntercomButton = styled.button`
  padding: 5px;
  border: 0;
  background: none;
  transition: opacity 0.3s;

  &:hover {
    text-decoration: none;
    opacity: 0.7;
  }
`

export const IntercomIcon = styled.img`
  height: 40px;
  width: 40px;
`
